import { render } from "./HiSimpleRemoteRequest.vue?vue&type=template&id=63db3b68"
import script from "./HiSimpleRemoteRequest.vue?vue&type=script&lang=js"
export * from "./HiSimpleRemoteRequest.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__